// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1K70f","content":"styles_content__2S0l4"};